/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { Field, FieldProps } from 'formik'
import { useServiceContext } from '../../../../../root'
import { RA_ACTION_TYPE } from './constants'
import SelectUserGroup from './SelectUserGroup'
import { ErrorMessageStyled } from '../../../../../components/shared/ErrorMessage'

interface ReadAcknowledgementStepFormProps {
  values: any
  setFieldValue: (field: string, value: any) => void
}

const ReadAcknowledgementStepForm: React.FC<ReadAcknowledgementStepFormProps> = ({ values, setFieldValue }) => {
  const context = useServiceContext()
  const { translate } = context.service.filter
  const createRAActionType = values.trainees?.createRAActionType || RA_ACTION_TYPE.FOR_NOBODY

  return (
    <>
      {/* Users/Groups Selection */}
      <div className="form-group">
        <label className="control-label">{translate('USERS_GROUPS')}</label>
        <SelectUserGroup
          isMulti={true}
          value={values.trainees?.usersGroups || []}
          onChange={(option) => {
            setFieldValue('trainees.usersGroups', option ? option : [])
          }}
          name="trainees.usersGroups"
        />
        <ErrorMessageStyled name="trainees.usersGroups" />
      </div>

      {/* Training Saving Type Radio Buttons */}
      <div className="form-group">
        <label className="control-label">{translate('BROWSER_SETTINGS_TRAINING_SAVING_TYPE_HEADLINE')}</label>
        <Field name="trainees.createRAActionType">
          {({ field }: FieldProps) => (
            <>
              <div className="radio">
                <label>
                  <input
                    {...field}
                    type="radio"
                    id={`0f9eddb8-de1e-48e7-9ac0-67b3aaaa8244-${RA_ACTION_TYPE.FOR_NOBODY}`}
                    value={RA_ACTION_TYPE.FOR_NOBODY}
                    checked={createRAActionType === RA_ACTION_TYPE.FOR_NOBODY}
                    onChange={() => setFieldValue('trainees.createRAActionType', RA_ACTION_TYPE.FOR_NOBODY)}
                  />
                  {translate('BROWSER_SETTINGS_TRAINING_SAVING_TYPE_FUTURE_LABEL')}
                </label>
              </div>
              <div className="radio">
                <label>
                  <input
                    {...field}
                    type="radio"
                    id={`0f9eddb8-de1e-48e7-9ac0-67b3aaaa8244-${RA_ACTION_TYPE.FOR_NEW_USERS_ONLY}`}
                    value={RA_ACTION_TYPE.FOR_NEW_USERS_ONLY}
                    checked={createRAActionType === RA_ACTION_TYPE.FOR_NEW_USERS_ONLY}
                    onChange={() => setFieldValue('trainees.createRAActionType', RA_ACTION_TYPE.FOR_NEW_USERS_ONLY)}
                  />
                  {translate('BROWSER_SETTINGS_TRAINING_SAVING_TYPE_NEW_NOW_LABEL')}
                </label>
              </div>
              <div className="radio">
                <label>
                  <input
                    {...field}
                    type="radio"
                    id={`0f9eddb8-de1e-48e7-9ac0-67b3aaaa8244-${RA_ACTION_TYPE.FOR_ALL_USERS}`}
                    value={RA_ACTION_TYPE.FOR_ALL_USERS}
                    checked={createRAActionType === RA_ACTION_TYPE.FOR_ALL_USERS}
                    onChange={() => setFieldValue('trainees.createRAActionType', RA_ACTION_TYPE.FOR_ALL_USERS)}
                  />
                  {translate('BROWSER_SETTINGS_TRAINING_SAVING_TYPE_ALL_NOW_LABEL')}
                </label>
              </div>
            </>
          )}
        </Field>
      </div>
    </>
  )
}

export default ReadAcknowledgementStepForm
